module.exports = __webpack_public_path__ + "img/electronic_use.e27149e7.svg";